import { MRT_TableOptions } from 'mantine-react-table';
import { ResourceIndexView } from '@app/types/blackroom-api';

import * as tableStylesAPI from '@features/Resource/ResourceTable/styles/index.css';
import { vars } from '@app/shared/themes/vars';

const baseConfig = {
  getRowId: (originalRow) => originalRow.id,
  mantineSelectCheckboxProps: {
    radius: 'xs',
    size: 'sm',
    __vars: {
      '--mantine-cursor-type': 'pointer',
    },
  },
  mantineSelectAllCheckboxProps: {
    radius: 'xs',
    size: 'sm',
    __vars: {
      '--mantine-cursor-type': 'pointer',
    },
  },
  mantinePaperProps: {
    style: {
      border: 'none',
      boxShadow: 'none',
      '--mrt-base-background-color': vars.colors.blackroomWhite,
      '--mrt-striped-row-background-color': vars.colors.blackroomWhite,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  },
  mantineTableHeadCellProps: {
    className: tableStylesAPI.tableHeader,
    style: {
      paddingTop: '1rem',
      paddingBottom: '1rem',
    },
  },
  mantineTableHeadRowProps: {
    className: tableStylesAPI.tableHeaderRow,
  },
  enablePagination: false,
  enableBottomToolbar: false,
  enableExpanding: true,
} as Partial<MRT_TableOptions<ResourceIndexView>>;

export default baseConfig;
